import { changeToasterState, toggleModal } from '../../../Store/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { TOASTER_STATE } from '../../../Model/Enums';
import { useDeleteIntegrationsByAccountantIdMutation } from '../../../Store/bankaccount';
import { currentBankAccountSelector } from '../../../Store/paramsBagSlice';

export const useOuterApiRevokeForm = () => {
  const dispatch = useAppDispatch();

  const [deleteIntegration, { isLoading }] = useDeleteIntegrationsByAccountantIdMutation();
  const currentBankAccount = useAppSelector(currentBankAccountSelector);
  const onsSubmit = async (event) => {
    event.preventDefault();
    if (currentBankAccount?.accountId) {
      try {
        await deleteIntegration({
          accountId: currentBankAccount?.accountId,
          companyId: currentBankAccount?.companyId,
        }).unwrap();
        dispatch(changeToasterState(TOASTER_STATE.AGGREG8_API_CONNECT_REVOKE_SUCCESS));
      } catch (e) {
        dispatch(changeToasterState(TOASTER_STATE.AGGREG8_API_CONNECT_REVOKE_FAILED));
      } finally {
        dispatch(toggleModal());
      }
    }
  };

  return { onsSubmit, isLoading };
};
